
Common = {


    loadBlueImpGallery: function  (gallery_id) {

        var g_id = gallery_id || 'blueimp_gallery';

        document.getElementById(g_id).onclick = function (event) {
            event = event || window.event;
            var target = event.target || event.srcElement,
                link = target.src ? target.parentNode : target,
                options = {
                    index: link,
                    event: event,
                    slideshowInterval: 2500,
                    preloadRange: 3,
                    transitionSpeed: 100,
                    fullScreen: false,
                    continuous: false
                },
                links = this.getElementsByTagName('a');
            blueimp.Gallery(links, options);
        };

    },


    otherItemsTintAndBorder: function  () {

        $(".other_items_wrap" ).on( "mouseover", ".other_item", function() {
            var tint = $('.item_label_tint', this);
            var border = $('.item_border', this);
            tint.css("opacity", 0.4);
            border.css("opacity", 1);
        });


        $(".other_items_wrap" ).on( "mouseleave", ".other_item", function() {
            var tint = $('.item_label_tint', this);
            var border = $('.item_border', this);
            tint.css("opacity", 0);
            border.css("opacity", 0);
        });

    },


    listItemsTintAndBorder: function  () {

        $(".list_items_wrap" ).on( "mouseover", ".list_item", function() {
            var tint = $('.item_label_tint', this);
            var border = $('.item_border', this);
            tint.css("opacity", 0.4);
            border.css("opacity", 1);
        });


        $(".list_items_wrap" ).on( "mouseleave", ".list_item", function() {
            var tint = $('.item_label_tint', this);
            var border = $('.item_border', this);
            tint.css("opacity", 0);
            border.css("opacity", 0);
        });

    }
    

    
}

